import { render } from "./HilfeImWald.vue?vue&type=template&id=589b25d1"
import script from "./HilfeImWald.vue?vue&type=script&lang=js"
export * from "./HilfeImWald.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__